export default [
    {
        path: '/pages/coupon/shopCouponManage',
        name: '/pages/coupon/shopCouponManage',
        component: () => import('@/views/coupon/shopCouponManage.vue')
    },
    {
        path: '/pages/coupon/userCouponManage',
        name: '/pages/coupon/userCouponManage',
        component: () => import('@/views/coupon/userCouponManage.vue')
    },
    {
        path: '/pages/coupon/couponGiveLogManage',
        name: '/pages/coupon/couponGiveLogManage',
        component: () => import('@/views/coupon/couponGiveLogManage.vue')
    },
    {
        path: '/pages/coupon/couponReceiveLogManage',
        name: '/pages/coupon/couponReceiveLogManage',
        component: () => import('@/views/coupon/couponReceiveLogManage.vue')
    },
    {
        path: '/pages/coupon/couponUseLogManage',
        name: '/pages/coupon/couponUseLogManage',
        component: () => import('@/views/coupon/couponUseLogManage.vue')
    },
    {
        path: '/views/goods/staffCollectedProduct',
        name: '/views/goods/staffCollectedProduct',
        component: () => import('@/views/goods/staffCollectedProduct.vue')
    }
]

